export default {
  name: "pubSection"
};
